import React from 'react'
import { Outlet } from 'react-router-dom'

const MainPromotions = () => {
  return (
    <div className=' w-full h-full'>{<Outlet/>}</div>
  )
}

export default MainPromotions